import {exibirMensagem, HttpVerbo, xfetch} from "../util";
import {Forca} from "../tipos/forca";

const url = '/forca'

export default class ForcaServico {

  static buscarForcas = async (): Promise<Forca[]> => {
    let res =
      await xfetch(url, {}, HttpVerbo.GET)
        .catch(e => alert(e.message))
    return res.json();
  }

  static salvarForca(dados: Forca) {
    return xfetch(url, dados, HttpVerbo.POST).catch(e => exibirMensagem(e.message))
  }
  static alterarForca(dados: Forca) {
    return xfetch(url, dados, HttpVerbo.PUT).catch(e => exibirMensagem(e.message))
  }
}